import styled from 'styled-components';
export const DatePicker = styled.div`
  .SingleDatePicker {
    width: 100%;
  }
  .SingleDatePickerInput {
    border: 0.1rem solid ${props => props.theme.checkoutPage.inputTextBorderColor};
    background: ${props => props.theme.checkoutPage.inputTextBackground};
    box-shadow: inset 0 0.1rem 0.2rem ${props => props.theme.checkoutPage.inputTextShadowColor};
  }
  .DateInput {
    background: transparent;
    width: 100%;
    padding: 0;
  }
  .DateInput__display-text {
    color: ${props => props.theme.checkoutPage.inputTextColor};
    font-size: 1.8rem;
    font-weight: normal;
    line-height: 3.8rem;
  }
  .DateInput__display-text--focused {
    background: ${props => props.theme.checkoutPage.inputTextBackground};
    border-color: ${props => props.theme.checkoutPage.inputTextBorderColor};
    color: ${props => props.theme.checkoutPage.inputTextColor};
    box-shadow: inset 0 0.1rem 0.2rem ${props => props.theme.checkoutPage.inputTextShadowColor};
  }
  .CalendarDay--selected {
    background: ${props => props.theme.datePicker.selected.background};
    border: 1px double ${props => props.theme.datePicker.background};
    color: ${props => props.theme.datePicker.selected.color};
  }
  .CalendarDay__button {
    font-weight: normal;
    font-size: 1.8rem;
  }
`;



// WEBPACK FOOTER //
// ./components/ReduxForm/RenderDatePicker.style.js